import { useMemo } from 'react';
import { ComponentProps } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDesiredCreditsAmount } from '../../../../store/account/selectors';
import { actions } from '../../../../store/account/accountSlice';
import { StyledSlider } from './styled';

const TOP_UP_OPTIONS = [
  { value: 500, label: '500' },
  { value: 1000 },
  { value: 3000, label: '3K' },
  { value: 5000 },
  { value: 10000, label: '10K' },
  { value: 15000 },
  { value: 20000, label: '20K' },
  { value: 25000 },
  { value: 30000, label: '30K' },
  { value: 40000 },
  { value: 50000, label: '50K' },
];

const valueLabelFormat = (valueIndex: number) => {
  const value = TOP_UP_OPTIONS[valueIndex].value;
  return `${value / 1000}K`;
};

type CreditsAmountSliderProps = ComponentProps<typeof StyledSlider>;

const CreditsAmountSlider = (props: CreditsAmountSliderProps) => {
  const dispatch = useDispatch();
  const desiredCreditsAmount = useSelector(selectDesiredCreditsAmount);

  const valueIndex = useMemo(
    () =>
      TOP_UP_OPTIONS.findIndex(({ value }) => value === desiredCreditsAmount),
    [desiredCreditsAmount]
  );

  const handleChange = (_event: Event, valueIndex: number | number[]) => {
    if (Array.isArray(valueIndex)) {
      return;
    }
    dispatch(actions.setDesiredCreditsAmount(TOP_UP_OPTIONS[valueIndex].value));
  };

  return (
    <StyledSlider
      value={valueIndex}
      onChange={handleChange}
      min={0}
      max={TOP_UP_OPTIONS.length - 1}
      step={1}
      valueLabelFormat={valueLabelFormat}
      marks={TOP_UP_OPTIONS.map((item, index) => ({
        ...item,
        value: index,
      }))}
      {...props}
    />
  );
};

export default CreditsAmountSlider;
